<template>
	<div class="form-headless-signup">
		<form @submit.prevent="submit">
			<!-- <b-form-group label="Your name" label-for="name">
				<b-form-input
					id="name"
					v-model="form.name"
					type="text"
					required
					placeholder="Nikola Tesla"
				></b-form-input>
			</b-form-group> -->
			<div class="form-group">
				<label for="your-name" class="form-label">Your name</label>
				<input
					ref="firstInput"
					v-model="form.name"
					type="text"
					class="form-control"
					id="your-name"
					placeholder=""
				/>
			</div>
			<div class="form-group">
				<div
					v-for="type in account_types"
					:key="type.key"
					class="custom-control custom-checkbox"
				>
					<input
						class="custom-control-input"
						type="radio"
						v-model="form.account_type"
						:name="type.name"
						:id="type.key"
						:value="type.key"
					/>
					<label class="custom-control-label" :for="type.key">
						{{ type.description }}
					</label>
				</div>
			</div>
			<button
				:class="['btn btn-primary', { disabled: lock === true }]"
				type="submit"
			>
				Start
				<div class="spinner-border spinner-border-sm" v-if="lock"></div>
			</button>
			<div class="form-error" v-if="errorMessage">
				{{ errorMessage }}
			</div>
		</form>
	</div>
</template>

<script>
import { required, minLength, between } from 'vuelidate/lib/validators';
import emailValidator from '@/lib/email-validator.js';
export default {
	data: function () {
		return {
			lock: false,
			errorMessage: '',
			account_types: [
				{
					name: 'Educational - Student',
					key: 'educational:student',
					description:
						"You're a student studying in college, university or high school",
				},
				{
					name: 'Educational - Educator',
					key: 'educational:educator',
					description:
						"You're a teacher, tutor or someone working in university",
				},
				{
					name: 'Content creation',
					key: 'content_creation',
					description:
						"You're creating content via blogging, vlogging, newsletters, etc.",
				},
				{
					name: 'Other',
					key: 'other',
					description: 'Other',
				},
			],
			form: {
				name: '',
				account_type: '',
				source: 'extension',
			},
		};
	},
	validations: {
		form: {
			name: {
				required,
			},
			account_type: {
				required,
			},
		},
	},
	methods: {
		reset: function () {
			this.form = {
				name: '',
				email: '',
				password: '',
				account_type: '',
				feature_type: '',
				source: 'webapp',
			};
		},
		async signup(data) {
			await this.$store.dispatch('user/setToken', data);
			this.$store.dispatch('afterLogin', null, { root: true });
			this.$store.commit('SET_AFTER_SIGNUP', null, { root: true });
		},
		error: function (str) {
			this.errorMessage = str;
		},
		onError: function () {
			this.error(
				`Something went wrong on our end. Please try again. Sorry for the trouble.`
			);
		},
		onMissingFields: function () {
			this.error(
				`We're preparing something special for you. Please fill in all fields so we can customize your experience.`
			);
		},
		async submit() {
			this.$v.$touch();
			this.lock = true;
			if (this.$v.$invalid) {
				this.onMissingFields();
				this.lock = false;
				return;
			}
			let response = await this.$store.dispatch(
				'user/headlessSignup',
				this.form
			);
			if (response && response.data) {
				this.signup(response.data);
				this.$emit('success');
				this.lock = false;
			} else {
				this.onError();
				this.lock = false;
			}
		},
	},
	mounted: function () {
		this.$refs.firstInput.focus();
	},
};
</script>

<style lang="scss">
.form-headless-signup {
	margin-top: var(--spacer-sm);
	.custom-control .custom-radio {
		background-color: rgba(0, 0, 0, 0.15);
		padding: 0.5rem;
		padding-left: 40px;
		border-radius: 8px;
		margin-bottom: 1rem;
		//background-color: transparent;
	}

	label {
		font-size: var(--font-size);
		margin-bottom: var(--margin-lg);
	}

	.custom-control-label {
		width: 100%;
		font-size: var(--font-size-sm);
		line-height: 1.4;
		margin-bottom: 0;

		h4 {
			margin-bottom: 0.2rem;
		}
		// &:before {
		// 	left: -26px;
		// }
		// &:after {
		// 	left: -26px;
		// }
		p {
			margin: 0;
			margin-top: var(--margin-sm);
		}
	}

	.spinner-border {
		margin-left: var(--margin-sm);
	}
}
</style>
